// src/components/layout/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaChartLine,
  FaStore,
  FaUsers,
  FaMotorcycle,
  FaClipboardList,
  FaMoneyBillWave,
  FaWallet,
  FaReceipt,
} from 'react-icons/fa';

const navItems = [
  { label: 'Dashboard', path: '/dashboard', icon: FaChartLine },
  { label: 'Outlets', path: '/outlets', icon: FaStore },
  { label: 'Customers', path: '/customers', icon: FaUsers },
  { label: 'Riders', path: '/riders', icon: FaMotorcycle },
  { label: 'Live Earnings', path: '/live-earnings', icon: FaWallet },
  { label: 'Rider Payouts', path: '/rider-payouts', icon: FaMoneyBillWave },
  { label: 'Restaurant Payouts', path: '/restaurant-payouts', icon: FaMoneyBillWave },
  { label: 'Dine-in Deposits', path: '/dine-in-deposits', icon: FaReceipt },
  { label: 'Orders', path: '/orders', icon: FaClipboardList },
];

export default function Sidebar() {
  const location = useLocation();

  return (
    <div style={styles.sidebar}>
      <div style={styles.brand}>
        <img src="/yabatho-logo.png" alt="YaBatho" style={styles.logoImage} />
        <div>
          <div style={styles.brandName}>YaBatho</div>
          <div style={styles.brandSub}>Admin</div>
        </div>
      </div>
      <ul style={styles.nav}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(`${item.path}/`);

          return (
          <li key={item.path}>
            <Link
              to={item.path}
              style={{
                ...styles.link,
                ...(isActive ? styles.activeLink : {}),
              }}
            >
              <Icon size={16} />
              {item.label}
            </Link>
          </li>
          );
        })}
      </ul>
    </div>
  );
}

const styles = {
  sidebar: {
    width: 260,
    height: '100vh',
    backgroundColor: '#0F3D2E',
    color: '#FFFDF7',
    padding: '24px 18px',
    borderRight: '1px solid rgba(201, 161, 74, 0.35)',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    zIndex: 30,
  },
  brand: {
    display: 'block',
    marginBottom: 32,
    padding: '8px 10px',
  },
  logoImage: {
    width: 170,
    height: 70,
    objectFit: 'contain',
    display: 'block',
    marginBottom: 10,
  },
  brandName: {
    fontSize: 20,
    fontWeight: 900,
    color: '#FFFDF7',
  },
  brandSub: {
    fontSize: 12,
    fontWeight: 800,
    color: '#C9A14A',
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  nav: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 14px',
    color: '#D7CEBC',
    textDecoration: 'none',
    fontWeight: 800,
    borderRadius: 8,
    marginBottom: 8,
    transition: 'background-color 160ms ease, color 160ms ease',
  },
  activeLink: {
    color: '#0F3D2E',
    backgroundColor: '#C9A14A',
  },
};
